import { Component, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'vehicle-update-modal',
  templateUrl: './vehicle-update-modal.component.html',
  styleUrls: ['./vehicle-update-modal.component.scss'],
})
export class VehicleUpdateModalComponent {
  @ViewChild('content') modelBox: any;
  @Input() public confirmationText: string;
  @Output() public okclick = new EventEmitter<void>();
  isShowModal: boolean = false;

  constructor(private modalService: NgbModal) {}

  public show(): void {
    this.isShowModal = true;
    this.modalService.open(this.modelBox, { backdrop: 'static', keyboard: false });
  }

  public confirm(): void {
    this.isShowModal = false;
    this.okclick.emit();
    this.modalService.dismissAll();
  }

  public close(): void {
    this.isShowModal = false;
    this.modalService.dismissAll();
  }
}
